/*----------------------------------------------------------------------------
|
|  A viewer and admin UI for documents and doc fragements in a tree
|  structure
|
| 
|
|  based on:
|
|  React JSONTree
|  http://eskimospy.com/stuff/react/json/
|  Copyright 2014, David Vedder
|  MIT Licence
|
\----------------------------------------------------------------------------*/
import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Returns the type of an object as a string.
 *
 * @param obj Object The object you want to inspect
 * @return String The object's type
 */
var objType  = function (obj) {
    var className = Object.prototype.toString.call(obj).slice(8, -1);
    return className;
}

/**
 * Mixin for stopping events from propagating and collapsing our tree all
 * willy nilly. 
 */
var SquashClickEventMixin = {
    handleClick: function (e) {
        e.stopPropagation();
    }
};

/**
 * Mixin for setting intial props and state and handling clicks on
 * nodes that can be expanded.
 */
var ExpandedStateHandlerMixin = {
    getDefaultProps: function () {
        return {data:[], initialExpanded: false};
    },
    getInitialState: function () {
        return {
            expanded: this.props.initialExpanded,
            createdChildNodes: false
        };
    },
    handleClick: function (e) {
        e.stopPropagation();
        this.setState({expanded: !this.state.expanded});
    },
    componentWillReceiveProps: function () {
        // resets our caches and flags we need to build child nodes again
        this.renderedChildren = [];
        this.itemString = false
        this.needsChildNodes= true;
    }
}; // NOT SUPPORTED ANYMORE, USE HIGHER ORDER COMPONENTS INSTEAD OF MIXINS OR DUPLICATION OF CODE


/**
 * Object node class. If you have an object, this is what you should use to 
 * display it.
 */
export class DocNode extends React.Component {

    // defaultProps (moved below class definition)

    // getInitialState
    // https://reactjs.org/docs/react-without-es6.html#setting-the-initial-state
    constructor(props) {
      super(props);
      this.state = {
        expanded: this.props.initialExpanded,
        createdChildNodes: false
      };
      this.needsChildNodes = true;
      this.renderedChildren = [];   
      // autobinding 
      // https://reactjs.org/docs/react-without-es6.html#autobinding
      this.handleClick = this.handleClick.bind(this);
      this.handleOpenDoc = this.handleOpenDoc.bind(this);
    }

    handleClick(e,path,nodeName,type) {

      $('#tplDesignerDelInfoSection').html("");
      $('#tplDesignerInfoSection').show();
      if(path !== undefined) {
        let splittedPath = path.split('/')
        if (splittedPath[2] === 'Recycled' && splittedPath[4] !== undefined) {
            // let item = this.props.recycledFileDetails.find(element => '/' + this.props.tenant+element.rItem === path+'/'+nodeName);
            // let dFrom = item ? item.oItem : null;
            let dFrom    = null;
            let dDate    = splittedPath[4]
            let user_id  = ""
            if (splittedPath.length == 5) {
              let k = this.props.recycledFileDetails
              for (let i = 0; i < k.length; i++) {
                if (k[i].timestamp && k[i].timestamp == dDate) {
                  dFrom    = k[i].object_key
                  user_id  = k[i].user_id
                  break;
                }
              }
            }
            let nHtml = `<span style="font-size:12px;" id="tplDesignerInfoSection">
                            Selected Document:&nbsp;
                            deleted from
                            <b>${dFrom}</b> on ${dDate}
                         </span>`;
            $('#tplDesignerDelInfoSection').html(nHtml);
            $('#tplDesignerInfoSection').hide();
        }
      }

        if (event.target.type === 'checkbox') {
          return;
        }
        e.stopPropagation();
        this.setState({expanded: !this.state.expanded});
    }
    componentWillReceiveProps() {
        // resets our caches and flags we need to build child nodes again
        this.renderedChildren = [];
        this.itemString = false
        this.needsChildNodes= true;
    }

    handleMore() {
      alert('more...');
      return false;
    }

    handleOpenDoc(path,docname) {
      if (this.props.openDoc) {
        return this.props.openDoc(path, docname);
      };
      return false;
    }
    showCheckBox(path) {
      let regex = /^$|^\/[^\/]*$/;
      return !(path === null || path === "" || regex.test(path));
    }
    /**
     * Returns the child nodes for each element in the object. If we have
     * generated them previously, we return from cache, otherwise we create 
     * them.
     */
    getChildNodes() {
        var node = this.props.node;
        var path = this.props.path + '/' + node.name;
        var tenant = this.props.tenant;
        if (this.state.expanded && this.needsChildNodes) {
            var obj = this.props.data;
            var childNodes = [];
            for (var i = 0; i < node.children.length; i += 1) {
                childNodes.push(
                    <DocNode node={node.children[i]} 
                             path={path} 
                             tenant={tenant} 
                             initialExpanded={false} 
                             addDoc={this.props.addDoc}  
                             deleteDoc={this.props.deleteDoc}  
                             openDoc={this.props.openDoc}
                             showImage={this.props.showImage}
                             enableCheckBox={this.props.enableCheckBox}
                             toggleCheckBoxFn={this.props.toggleCheckBoxFn}
                             sortRecycle={this.props.sortRecycle}
                             recycledFileDetails={this.props.recycledFileDetails}
                    />
                );
            }
            this.needsChildNodes = false;
            this.renderedChildren = childNodes;
        }
        return this.renderedChildren;
    }


    render() {

        var node    = this.props.node;
        var tenant  = this.props.tenant;
        var path    = this.props.path;
        //var pathImg = (tenant == "HPQ")?this.props.path:'/' + tenant + this.props.path;
        if(node.pOPath) path = '/' + this.props.tenant + '/' + node.pOPath
        var pathImg = path;

        var more    = <noscript/>
        var del     = <noscript/>
        var show    = <noscript/>
        var showImg = <noscript/>
        var showCB  = <noscript/>

        if (this.props.enableCheckBox && this.showCheckBox(path) ) {
            showCB  = <input  key ={Date.now() + Math.random()}
                                      type="checkbox"
                                      onChange={ (event) => {
                                                              event.stopPropagation();
                                                              this.props.toggleCheckBoxFn(event, path, node);
                                                }}
                                      style={{ height: '12px', width: '12px', marginRight: '5px' }}
                                    />
        }
        if (this.props.addDoc) {
          more = <a onClick={this.props.addDoc.bind(null, path, node)} className="actionButton">more</a>
        }
        if (this.props.deleteDoc) {
          del = <a onClick={this.props.deleteDoc.bind(null, path, node)} className="actionButton">x</a>
        }
        if (this.props.showImage) {
          show = <a onClick={this.props.showImage.bind(null, path, node.fullname)} className="actionButton">show</a>
          showImg = <a onClick={this.props.showImage.bind(null, pathImg, node.fullname)} className="actionButton">show</a>
        }

        if(node.noMore) {
          more    = <noscript/>
          del     = <noscript/>
          show    = <noscript/>
          showImg = <noscript/>
          showCB  = <noscript/>
        }

        if (node.type == "folder") {

            var childListStyle = {
                display: (this.state.expanded) ? 'block' : 'none'
            };
            var cls = "object parentNode";
            var iconCls = "glyphicon glyphicon-folder-close";
            if (this.state.expanded) {
              cls += " expanded";
              iconCls = "glyphicon glyphicon-folder-open";
            }
            return (
                <li className={cls} onClick={(e) => this.handleClick(e,path,node.name,'folder')} >
                    <div className="actionLine">
                      {showCB}
                      <i className={iconCls}></i>
                      &nbsp;&nbsp;&nbsp;
                      <label>{node.name}</label> 
                      {more}
                      &nbsp;&nbsp;
                      {del}
                    </div>
                    <ul style={childListStyle}>
                        { this.getChildNodes() }
                    </ul>
                </li>
            );
        } else
        if (node.type == "template") {
            var cls = 'templateNode'
            if (node.selected) {
              cls += ' selected';
            }
            if (node.changed) {
              cls += ' changed';
            }
            return (
                <li className={cls} onClick={(e) => this.handleClick(e,path,node.name,'template')}>
                  <div className="actionLine">
                    {showCB}
                    <i className="glyphicon glyphicon-envelope"></i>
                    &nbsp;&nbsp;
                    <label onClick={this.handleOpenDoc.bind(null, path, node)}>{node.name}</label>
                    &nbsp;&nbsp;
                    {more}
                    &nbsp;&nbsp;
                    {del}
                  </div>
                </li> 
            ) 
        } else
        if (node.type == "block") {
            var cls = 'blockNode'
            if (node.selected) {
              cls += ' selected';
            }
            return (
                <li className={cls} onClick={(e) => this.handleClick(e,path,node.name,'block')}>
                  <div className="actionLine">
                    {showCB}
                    <i className="glyphicon glyphicon-th-large"></i>
                    &nbsp;&nbsp;
                    <label onClick={this.handleOpenDoc.bind(null, path, node)}>{node.name}</label>
                    &nbsp;&nbsp;
                    {more}
                    &nbsp;&nbsp;
                    {del}
                   </div>
                </li> 
            )  
        } else
        if (node.type == "pdf") {
            return (
                <li className="pdfNode" onClick={(e) => this.handleClick(e,path,node.name,'pdf')}>
                    <div className="actionLine">
                      {showCB}
                      <i className="glyphicon glyphicon-file"></i>
                      &nbsp;&nbsp;
                      <label>{node.name}</label>
                      {show}
                      &nbsp;&nbsp;
                      {more}
                      &nbsp;&nbsp;
                      {del}
                    </div>
                </li> 
            )  
        } else
        if (node.type == "picture") {
            return (
                <li className="pictureNode" onClick={(e) => this.handleClick(e,path,node.fullname,'picture')}>
                    <div className="actionLine">
                      {showCB}
                      <i className="glyphicon glyphicon-picture"></i>
                      &nbsp;&nbsp;
                      <label>{node.fullname}</label>
                      {showImg}
                      &nbsp;&nbsp;
                      {more}
                      &nbsp;&nbsp;
                      {del}
                    </div> 
                </li> 
            )  
        } else
        if (node.type == "unknown") {
            return (
                <li className="unknownNode" onClick={(e) => this.handleClick(e,path,node.name,'unknown')}>
                    <div className="actionLine">
                      {showCB}
                      <i className="glyphicon glyphicon-question-sign"></i>
                      &nbsp;&nbsp;
                      <label>{node.name}</label>
                      <a onClick={this.handleShow} className="actionButton">show</a>
                      &nbsp;&nbsp;
                      {del}
                    </div> 
                </li> 
            )  
        } else {
            console.log('?? strange:', node);
            return null;
        }
    }
};

// defaultProps
// https://reactjs.org/docs/react-component.html#defaultprops
DocNode.defaultProps = {
  data:[], initialExpanded: false,
};


function getTimePeriod(d) {
  let today = new Date();
  let diffInDays = Math.floor((today - d) / (1000 * 60 * 60 * 24));

  if (diffInDays <= 7) {
      return 'Last 7 days';
  } else if (diffInDays <= 21 && diffInDays > 7 ) {
      return 'Last 21 days';
  } else {
      return 'More than 21 days ago';
  }
}


function addOPath(addExtra,node, parentPath = '',oPath) {
  let woPath = node.oPath ? node.oPath : ( oPath ? `${oPath}/${node.name}` : node.name )
  let pwoPath = node.oPath ? node.oPath : ( oPath ? oPath : node.name )

  node.oPath = addExtra + woPath
  node.pOPath = addExtra + pwoPath
  const currentPath = parentPath ? `${parentPath}/${node.name}` : node.name;

  // Recursively add oPath to children if they exist
  if (node.children && node.children.length > 0) {
      node.children.forEach(child =>
          addOPath(addExtra,child, currentPath,woPath));
  }
}

function sortAndGroupBy(structure, key) {

  if(key == 'folder') return structure
  let order = 'asc'
  let groupedFolders = {};

  for (let i = 0; i < structure.children.length; i++) {
    // console.log(structure.children[i].name)
    if (structure.children[i].name === "Recycled") {
      let recycledFolder = structure.children[i]

      recycledFolder.children.forEach(subfolder => {
        // console.log("Subfolder is ",subfolder)
        // console.log("===>",subfolder.children,subfolder.children[0],subfolder.children.length)

        if (typeof subfolder.children === 'undefined') { return }
        if (subfolder.children.length == 0) {
          let keyValue = 'undef'
            if (!groupedFolders[keyValue]) {
              groupedFolders[keyValue] = {
                  "name": keyValue,
                  "type": "folder",
                  "oPath":"Recycled",
                  "pOpath":"",
                  "noMore": true,
                  "children": [
                    {
                      "name": subfolder.name,
                      "type": subfolder.type,
                      "oPath":"Recycled/"+subfolder.name,
                      "pOpath":"Recycled",
                      "children": []
                    }
                  ]
              };
          }
          let subFolderIndex = groupedFolders[keyValue].children.findIndex(child => child.name === subfolder.name);
          if ( subFolderIndex == -1 ) {
            groupedFolders[keyValue].children.push({
                      "name": subfolder.name,
                      "type": subfolder.type,
                      "oPath":"Recycled/"+subfolder.name,
                      "pOpath":"Recycled",
                      "children": []
                    })
            subFolderIndex = groupedFolders[keyValue].children.findIndex(child => child.name === subfolder.name);
          }
          groupedFolders[keyValue].children[subFolderIndex].children.push(...subfolder.children);

        }

        for (let j = 0; j < subfolder.children.length; j++) {
          let cChild = subfolder.children[j]
          let date = new Date(cChild.name.substring(0, 10));
          let period = getTimePeriod(date);
          let month = date.getMonth() + 1;
          let year = date.getFullYear();
          let month1 = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2);
          let keyValue = "";

          switch(key) {
              case 'month':
                  keyValue = `${year}-${month}`;
                  keyValue = `${month1}`;
                  break;
              case 'period':
                  keyValue = period;
                  break;
              case 'folder':
                  keyValue = '';
                  break;
              case 'day':
                  keyValue = cChild.name.substring(0, 10);
                  break;
              default:
                  keyValue = cChild.name.substring(0, 10);
          }

          if (!groupedFolders[keyValue]) {
              groupedFolders[keyValue] = {
                  "name": keyValue,
                  "type": "folder",
                  "oPath":"Recycled",
                  "pOpath":"",
                  "noMore": true,
                  "children": [
                    {
                      "name": subfolder.name,
                      "type": subfolder.type,
                      "oPath":"Recycled/"+subfolder.name,
                      "pOpath":"Recycled",
                      "children": []
                    }
                  ]
              };
          }

          let subFolderIndex = groupedFolders[keyValue].children.findIndex(child => child.name === subfolder.name);

          if ( subFolderIndex == -1 ) {
            groupedFolders[keyValue].children.push({
                      "name": subfolder.name,
                      "type": subfolder.type,
                      "oPath":"Recycled/"+subfolder.name,
                      "pOpath":"Recycled",
                      "children": []
                    })
            subFolderIndex = groupedFolders[keyValue].children.findIndex(child => child.name === subfolder.name);
          }

          let tempVar = {...subfolder.children[j]}
          addOPath(`Recycled/${subfolder.name}/`,{...subfolder.children[j]})

          groupedFolders[keyValue].children[subFolderIndex].children.push(...subfolder.children[j].children);
        }

      })

      const sortedGroupedFolders = Object.values(groupedFolders).sort((a, b) => {
        if (key === 'day' || key === 'month') {
          const dateA = new Date(a.name);
          const dateB = new Date(b.name);
          return order === 'asc' ? dateA - dateB : dateB - dateA;
        } else if (key === 'period') {
          const cOrder = ["Last 7 days", "Last 21 days", "More than 21 days ago"];
          return cOrder.indexOf(a.name) - cOrder.indexOf(b.name);
        } else {
          const numA = parseFloat(a.name);
          const numB = parseFloat(b.name);
          return order === 'asc' ? numA - numB : numB - numA;
        }
      });

      structure.children[i].children = sortedGroupedFolders;
    }
  }
  return structure;
}

export default class DocTree extends React.Component {

    // defaultProps (moved below class definition)

    render() {
        var rootNode;
        if (this.props.node && this.props.node.type) {
          var node = this.props.node
          try {
            if(this.props.sortRecycle) {
              node = _.cloneDeep(this.props.node);
              node = sortAndGroupBy(node,this.props.sortRecycle)
            }
          } catch (error) {
              console.error('An error occurred while sorting and grouping:', error);
              node = _.cloneDeep(this.props.node);
          }
            rootNode = <DocNode node={node}
                                path={this.props.path} 
                                tenant={this.props.tenant} 
                                initialExpanded={false} 
                                openDoc={this.props.openDoc}  
                                addDoc={this.props.addDoc}  
                                deleteDoc={this.props.deleteDoc}  
                                showImage={this.props.showImage}
                                enableCheckBox={this.props.enableCheckBox}
                                toggleCheckBoxFn={this.props.toggleCheckBoxFn}
                                sortRecycle={this.props.sortRecycle}
                                recycledFileDetails={this.props.recycledFileDetails}
                       />
        }
        return (
           <div>
            <ul className="docTree">
                { rootNode }
            </ul>
           </div> 
        );
    }
};

// defaultProps
// https://reactjs.org/docs/react-component.html#defaultprops
DocTree.defaultProps = {
  path: '/'
};